import type { TReviewFacetOption } from '@onesource/schemas';
import { FC, ReactNode } from 'react';

import { ReviewFilterPanel, type TReviewFilterValue } from './review-filter-panel';
import { ReviewFilterShell } from './review-filter-shell';

interface ReviewFilterProps {
  label: string;
  /** Plural noun for the panel copy. */
  noun: string;
  icon: ReactNode;
  value: TReviewFilterValue;
  onChange: (value: TReviewFilterValue) => void;
  options: TReviewFacetOption[] | undefined;
  isLoading: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  showAvatars?: boolean;
}

/** One list filter: pick values (include / exclude), each with its count. */
export const ReviewFilter: FC<ReviewFilterProps> = ({
  label,
  noun,
  icon,
  value,
  onChange,
  options,
  isLoading,
  open,
  onOpenChange,
  showAvatars,
}) => (
  <ReviewFilterShell
    label={label}
    icon={icon}
    selectedLabels={value.ids.map(id => value.labels[id] ?? '1 selected')}
    mode={value.mode}
    open={open}
    onOpenChange={onOpenChange}
  >
    <ReviewFilterPanel
      title={`Filter by ${label.toLowerCase()}`}
      noun={noun}
      options={options}
      isLoading={isLoading}
      value={value}
      onChange={onChange}
      onDone={() => onOpenChange(false)}
      showAvatars={showAvatars}
    />
  </ReviewFilterShell>
);
